import styled from "styled-components"

import { spacing } from "@izettle/otto"

import { Button } from "../../button"

export const StyledButton = styled(Button)`
  margin-top: ${spacing.medium};
`
